module.exports = __webpack_public_path__ + "03_long_black.f7499e6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/03_long_black.png
// module id = zrdT
// module chunks = 0